<template>
  <div class="donate">
    <section class="page-hero">
      <div class="container">
        <span class="eyebrow eyebrow-light">{{ $t('donate.hero.eyebrow') }}</span>
        <h1>{{ $t('donate.hero.title') }}</h1>
        <p>{{ $t('donate.hero.subtitle') }}</p>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="card coming-soon">
          <IconBadge icon="heart" tone="amber" size="lg" />
          <h2>{{ $t('donate.disabled.title') }}</h2>
          <p>{{ $t('donate.disabled.text') }}</p>
          <div class="contact-line">
            <IconBadge icon="phone" tone="green" size="sm" />
            <a href="tel:+919826033529">+91-9826033529</a>
          </div>
          <div class="contact-line">
            <IconBadge icon="mail" tone="green" size="sm" />
            <a href="mailto:info@hindkrantisenafoundation.org">info@hindkrantisenafoundation.org</a>
          </div>
          <router-link to="/contact" class="btn btn-primary">{{ $t('donate.disabled.contactBtn') }}</router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import IconBadge from '@/components/IconBadge.vue';

export default {
  name: 'DonateUs',
  components: { IconBadge },
};
</script>

<style scoped>
.page-hero { background: linear-gradient(135deg, var(--charcoal-dark), var(--charcoal)); color: #fff; padding: 76px 0; text-align: center; }
.eyebrow-light { color: #8FDDD8; text-transform: uppercase; letter-spacing: 1.5px; font-weight: 700; font-size: 0.8rem; }
.page-hero h1 { font-size: clamp(1.7rem, 3.4vw, 2.3rem); margin: 12px 0 10px; }
.page-hero p { color: rgba(255,255,255,0.88); margin: 0 auto; max-width: 560px; }

.coming-soon {
  max-width: 520px; margin: 0 auto; text-align: center;
  display: flex; flex-direction: column; align-items: center; gap: 10px;
}
.coming-soon h2 { color: var(--charcoal); margin-top: 8px; }
.coming-soon p { color: var(--muted); margin: 0 0 6px; }
.contact-line { display: flex; align-items: center; gap: 10px; font-weight: 600; }
.contact-line a { color: var(--brand-teal-dark); text-decoration: none; }
.coming-soon .btn { margin-top: 12px; }
</style>
